import { useMemo } from "react";
import { readStatsConfig } from "./config";
import { StatsWidget } from "./StatsWidget";

export function StatsApp() {
  const cfg = useMemo(readStatsConfig, []);
  return <StatsWidget cfg={cfg} />;
}
